'use client'

import { LocalizedLink } from '../LocalizedLink'
import DatoLink from '../DatoLink/DatoLink'
import { NotFoundFragment } from './NotFound.generated'
import EventPageNotFound from '../GTM/Events/EventPageNotFound'

type NotFoundProps = {
	fragment?: NotFoundFragment
	locale: string
}

export default function NotFound({ fragment, locale }: NotFoundProps) {
	return (
		<>
			<EventPageNotFound />
			<div className="min-h-screen bg-white text-black flex flex-col items-center justify-center">
				<div className="flex items-center gap-6">
					<span className="text-2xl font-medium border-r border-gray-600 pr-6">
						404
					</span>
					<span className="text-lg">
						{fragment?.message || 'Page not found'}
					</span>
				</div>
				<div className="mt-10 flex gap-4">
					<LocalizedLink
						locale={locale}
						href={'/'}
						className="underline text-red-500 font-bold hover:text-red-600 focus:outline focus:outline-2 focus:outline-red-500 transition visited:text-red-500"
						title="home"
						prefetch={false}
					>
						{fragment?.backHomeText || 'Back to home'}
					</LocalizedLink>
					<span className="text-gray-600">|</span>
					<DatoLink
						locale={locale}
						fragment={fragment?.contactPageLink}
						className="underline text-red-500 font-bold hover:text-red-600 focus:outline focus:outline-2 focus:outline-red-500 transition visited:text-red-500"
					>
						{fragment?.contactPageLink?.label?.toLowerCase() || 'Contact us'}
					</DatoLink>
				</div>
			</div>
		</>
	)
}
